var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightbulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 960 960",
    width: "24px",
    fill: "#006B87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 880Q447 880 423.5 856.5Q400 833 400 800L560 800Q560 833 536.5 856.5Q513 880 480 880ZM320 760L320 680L640 680L640 760L320 760ZM330 640Q261 599 220.5 530Q180 461 180 380Q180 255 267.5 167.5Q355 80 480 80Q605 80 692.5 167.5Q780 255 780 380Q780 461 739.5 530Q699 599 630 640L330 640ZM354 560L606 560Q651 528 675.5 481Q700 434 700 380Q700 288 636 224Q572 160 480 160Q388 160 324 224Q260 288 260 380Q260 434 284.5 481Q309 528 354 560Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightbulb);
export default __webpack_public_path__ + "static/media/Icon_Lightbulb.a57c88cfaed0d4d6c9af81c243525f4f.svg";
export { ForwardRef as ReactComponent };